import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  inject,
  Injector,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { Store } from '@ngxs/store';
import { debounceTime, Subscription, tap } from 'rxjs';
import { MainTableFilterModulesEnum } from 'src/app/core/enums/main-table-filter-modules.enum';
import { MainTableFilterIdentification } from 'src/app/core/models/main-table-filter-identification.model';
import { ApplySearch } from 'src/app/core/state/main-table-filter.actions';
import { MainTableFilterState } from 'src/app/core/state/main-table-filter.state';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IPageModel } from 'src/app/shared/models/page.model';

@Component({
  selector: 'app-main-table-search',
  templateUrl: './main-table-search.component.html',
  styleUrls: ['./main-table-search.component.scss'],
  standalone: false,
})
export class MainTableSearchComponent implements OnChanges, OnInit, OnDestroy {
  private readonly injector = inject(Injector);

  @Input() totalPages: any;
  @Input() additional: any;
  @Input() moduleName: MainTableFilterModulesEnum;

  currentPageDetails: IPageModel;
  searchTerm = new FormControl<string>('');

  private pagingDetailsSub?: Subscription;
  private searchDebounceSub = new Subscription();
  private filterIdentification: MainTableFilterIdentification;
  private currentSearchTerm: string;

  constructor(private store: Store) {}

  ngOnChanges(_changes: SimpleChanges): void {
    if (
      this.filterIdentification &&
      _changes.additional?.currentValue !== _changes.additional?.previousValue
    ) {
      this.filterIdentification.additional = _changes.additional.currentValue;
      this.checkIfSearchIsPresent();
    }
  }

  ngOnInit(): void {
    this.listenToSearchChanges();
    this.checkIfSearchIsPresent();
  }

  ngOnDestroy(): void {
    this.pagingDetailsSub?.unsubscribe();
    this.searchDebounceSub.unsubscribe();
  }

  searchChanged(searchTerm: any): void {
    this.store.dispatch(new ApplySearch(this.moduleName, searchTerm, this.additional));
  }

  private listenToSearchChanges(): void {
    const debounceTimeCounter = 500;
    this.searchDebounceSub.add(
      this.searchTerm.valueChanges
        .pipe(
          debounceTime(debounceTimeCounter),
          tap((searchTerm: any) => {
            if (searchTerm !== this.currentSearchTerm) {
              this.searchChanged(searchTerm);
            }
          })
        )
        .subscribe()
    );
  }

  private checkIfSearchIsPresent(): void {
    this.filterIdentification = new MainTableFilterIdentification(this.moduleName, this.additional);
    this.pagingDetailsSub?.unsubscribe();
    const pagingSig = this.store.selectSignal(
      MainTableFilterState.getPagingDetails(this.filterIdentification)
    );
    this.pagingDetailsSub = toObservable(pagingSig, { injector: this.injector })
      .pipe(
        tap((pagingDetails: MainTableFilterModel | undefined) => {
          if (pagingDetails?.searchTerm && pagingDetails?.searchTerm !== this.currentSearchTerm) {
            this.currentSearchTerm = pagingDetails?.searchTerm;
            this.searchTerm.setValue(pagingDetails?.searchTerm);
            setTimeout(() => {
              this.searchChanged(pagingDetails?.searchTerm);
            }, 0);
          }
        })
      )
      .subscribe();
  }
}
